import {
  AVAILABLE_ROOM,
  CREATE_DRAFT,
  CREATE_MEETING,
  CREATE_MINUTES,
  DRAFT_DETAILS,
  ERRORS,
  GET_ALL_DRAFTS,
  GET_ALL_INVITED_IN,
  GET_ALL_MEETINGS,
  GET_MEETING,
  MeetingType,
  MEETING_LIST_ALL,
  MEETING_LIST_ALL_ERROR,
  MINUTES_TEMPLATE,
  RESOURCER_LIST_ALL,
  RESOURCER_LIST_ALL_ERROR,
  UPDATE_MEETING,
  MINUTES_DETAILS,
} from "./type";

export const initialState = {
  meetings: [],
  invitedIn: [],
  rooms: [],
  meeting: {},
  minutesTemplate: null,
  errorMessage: null,
  successMessage: null,
  resources: [],
  resourcesError: null
};

export const meetingReducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case ERRORS:
      return { ...state, errorMessage: payload, successMessage: null };
    case CREATE_MEETING:
      return { ...state, successMessage: payload, errorMessage: null };
    case GET_ALL_MEETINGS:
      return {
        ...state,
        meetings: payload,
        successMessage: null,
        errorMessage: null,
      };
    case GET_ALL_INVITED_IN:
      return {
        ...state,
        invitedIn: payload,
        successMessage: null,
        errorMessage: null,
      };
    case GET_MEETING:
      return {
        ...state,
        meeting: payload,
        successMessage: null,
        errorMessage: null,
      };
    case UPDATE_MEETING:
      return { ...state, successMessage: payload, errorMessage: null };
    case MINUTES_TEMPLATE:
      return {
        ...state,
        minutesTemplate: payload,
        successMessage: null,
        errorMessage: null,
      };
    case CREATE_MINUTES:
      return { ...state, successMessage: payload, errorMessage: null };
    case AVAILABLE_ROOM:
      return {
        ...state,
        rooms: payload,
        successMessage: null,
        errorMessage: null,
      };
    case RESOURCER_LIST_ALL:
      return {
        ...state,
        resources: payload,
        resourcesError: null
      };
    case RESOURCER_LIST_ALL_ERROR:
      return {
        ...state,
        resourcesError: payload,
      };
    case MEETING_LIST_ALL:
      return {
        ...state,
        meetingList: payload,
        meetingListError: null
      };
    case MEETING_LIST_ALL_ERROR:
      return {
        ...state,
        meetingListError: payload,
      };
    case ERRORS:
      return { ...state, errorMessage: payload, successMessage: null };
    case CREATE_DRAFT:
      return { ...state, successMessage: payload, errorMessage: null };
    case GET_ALL_DRAFTS:
      return { ...state, drafts: payload, errorMessage: null, successMessage: null };
    case DRAFT_DETAILS:
      return { ...state, draft: payload, errorMessage: null, successMessage: null };
    case MINUTES_DETAILS:
      return { ...state, minutesDetails: payload, errorMessage: null, successMessage: null };
    default:
      return state;
  }
};
